'use client';
import React from 'react';
import { usePathname } from 'next/navigation';

import DesignSystemComponents from './DesignSystemComponents';

const DesignSystemClient = () => {
  const pathname = usePathname();
  const isSpanish = (pathname || '/').startsWith('/es');
  return (
    <div className='design-system-page'>
      <DesignSystemComponents isSpanish={isSpanish} />
    </div>
  );
};

export default DesignSystemClient;
